import { render, staticRenderFns } from "./PageEventHistory.vue?vue&type=template&id=3db31779&"
import script from "./PageEventHistory.vue?vue&type=script&lang=js&"
export * from "./PageEventHistory.vue?vue&type=script&lang=js&"
import style0 from "./PageEventHistory.vue?vue&type=style&index=0&id=3db31779&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports